import { Component, Input } from "@angular/core";


@Component({
    selector: 'app-event-column',
    template: `
    `,
    standalone: true,
    imports: [
    ],
    styles: [
        `
        `
    ]
})

export class EventColumnComponent {
@Input() value: string = '';
}